module.exports = __webpack_public_path__ + "img/logo.3ce33e20.png";